<template>
  <v-container>
    <div class="title-icon">
      <h1 class>{{ $t('labels.e-book2') }}</h1>      
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div> 
        
    <template v-if="isApprentice">            
      <template v-if="bookActive==false && selectedBook && selectedBook.bookStatus && selectedBook.bookStatus.id">
      <MessageBox class="my-5" type="info" v-if="selectedBook.bookStatus.id=='4'">
        <h6>{{ $t("ebook.pause-title") }}</h6>
        <p v-html="$t('ebook.pause-text', {startdate: getDate(selectedEducation.startDate)})"></p>
      </MessageBox>
      <MessageBox class="my-5" type="info" v-else-if="isAfterStartDate==false && selectedEducation">
        <h6>{{ $t("ebook.start-mb-title") }}</h6>
        <p v-html="$t('ebook.start-mb-text', {startdate: getDate(selectedEducation.startDate)})"></p>
      </MessageBox>
        <!-- <MessageBox class="my-5" type="info" v-else-if="selectedBook.bookStatus.id=='1'">
          <h6>{{ $t("ebook.inactive-title2") }}</h6>
          <p v-html="$t('ebook.inactive-text2', {startdate: getDate(selectedEducation.startDate)})"></p>
        </MessageBox> -->
        <MessageBox class="my-5" type="info" v-else-if="selectedBook.bookStatus.id=='5'">
          <h6>{{ $t("ebook.inactive-title3") }}</h6>
          <p v-html="$t('ebook.inactive-text3', {startdate: getDate(selectedEducation.startDate)})"></p>
        </MessageBox>
        <MessageBox class="my-5" type="info" v-else>
          <h6>{{ $t("ebook.inactive-title") }}</h6>
          <p v-html="$t('ebook.inactive-text', {startdate: getDate(selectedEducation.startDate)})"></p>
        </MessageBox>
      </template>
      <ButtonArray text="left" :bookActive="bookActive" :type="'action'" :options="buttons" />    
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import MessageBox from "@/components/Common/MessageBox";
import ButtonArray from '@/components/Common/ButtonArray'

const SugarDate = require('sugar/date')

export default {
  name: 'ApplicationStart',

  components: {    
    ButtonArray,
    MessageBox
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    bookId: -1,
    bookActive: false,    
    isAfterStartDate: false,
    selectedEducation: {},
    selectedBook: {},
  }),

  created() {
    this.init()
  },

  watch: {},

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor']),
    buttons() {
      return [
        {
          user: 'isApprentice',
          route: {name: 'EbookReportElement', params: {id: this.$route.params.id}},
          actionIcon: '$sl-ebook-add',
          title: this.$t('ebook.report-element'),
          disabled: !this.bookActive
        },
        {
          user: 'isApprentice',
          route: {name: 'EbookReportOverviewStart'},
          actionIcon: '$sl-checklist-flip',
          title: this.$t('ebook.show-reports'),
          disabled: !this.isAfterStartDate
        },
        {
          user: 'isApprentice',
          route: {name: 'EbookEducationStart'},
          actionIcon: '$sl-owl',
          title: this.$t('ebook.show-education')
        }
      ]
    }
  },

  filters: {
    filterGenitiveName(name) {
      if (name && name.length > 0) {
        if (name.slice(-1) == 's') return name
      }

      return name + 's'
    }
  },
  methods: {
    init(){
      //console.log("curr::", this.currentUser)
      if(this.currentUser && this.currentUser.books && this.currentUser.educations && this.$route.params.id){
        let book = this.currentUser.books.find(b => b.id==this.$route.params.id)
        
        if(book)
        {          
          let education = this.currentUser.educations.find(e => e.id==book.educationId)
          if(education){
            this.selectedEducation=education

          if(SugarDate.Date.is(new Date(), education.startDate) || SugarDate.Date.isAfter(new Date(), education.startDate))
              this.isAfterStartDate=true
          else
            this.isAfterStartDate=false

          if(book.bookStatus.id==2)
              this.bookActive=true  
            else 
              this.bookActive=false
            
            this.selectedBook=book
            //console.log("selectedBook::", this.selectedBook)
          }
        }
        else {
          this.selectedBook={}
          this.selectedEducation={}
        }
      }
    },
    getDate(d){
      return SugarDate.Date(d).format('%Y-%m-%d')
    }
  }
}
</script>

<style lang="scss">

</style>
